import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-3',
    helperText: 'mt-1 text-sm font-light'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-error'
      }
    }
  }
});
